import { getYear } from "date-fns";

/**
 * Gets the current year
 */
export default function (date: number | Date)
{
    return getYear(date);
}